import React, { Component } from "react";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./UsersRoleList.module.css";
import moment from "moment";
import { fetchUserRolesList } from "../../../redux";
import { connect } from "react-redux";
import api from "../../../utils/Api";
import ttmLodader from "../../../assets/images/ttm-loader.gif";
import { Permissions, checkIfPermitted } from "../../../services/RolePermissionService";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class UsersRoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      rolesData: [],
      roleId: "",
      assign_role: "",
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      successMessage: "",
      errorMessage: "",
      isDataFetched: false,
      usersRoleList: [],
    };
    this.toggle = this.toggle.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'User Roles - TechToMedix';
   await this.props.fetchUserRolesList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.userRolesListData && 
      this.props.userRolesListData.userRolesList &&
      this.props.userRolesListData.userRolesList.roleList) {
        this.setState({
          usersRoleList: this.props.userRolesListData.userRolesList.roleList
        })
    }
    setTimeout(() => {
      if (this.props.userRolesListData.userRolesList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callUserRoleListAPI = async() => {
    this.setState({
      usersRoleList: [],
    });
    await this.props.fetchUserRolesList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(!this.props.userRolesListData.loading){
      this.setState({
        usersRoleList: this.props.userRolesListData.userRolesList.roleList
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callUserRoleListAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callUserRoleListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callUserRoleListAPI();
    });
  };

  // toggle a modal
  toggle(val) {
    const roles = this.props.userRolesListData.userRolesList.roleList;
    let key = val.role_name;
    const filterRoles = roles.filter(function (val) {
      return val.role_name !== key;
    });

    this.setState((prevState) => ({
      roleId: val.role_id,
      isModalOpen: !prevState.isModalOpen,
      rolesData: filterRoles,
    }));
  }

  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="Edit User Role" to={{ pathname: `/app/user-role-creation/${row.role_id}` }}>
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        {Number(row.role_id) !== 1 &&
          Number(row.role_id) !== 2 &&
          Number(row.role_id) !== 3 &&
          Number(row.role_id) !== 4 &&
          Number(row.role_id) !== 5 && (
            <Link title="Delete User Role"
              class="action-icons relatedpartylist-add-icon"
              onClick={() => this.toggle(row)}
            >
              <i class="fa fa-trash"></i>
            </Link>
          )}
      </div>
    );
  }

  onChangeHandler(event) {
    this.setState({
      assign_role: event.target.value,
    });
  }

  // Delete role api
  onSubmit = async (e) => {
      this.setState({
        errorMessage: "",
      });
    e.preventDefault();
    try {
      const response = await api.delete("user/role/delete", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          role_id: this.state.roleId,
          assign_to_role_id: Number(this.state.assign_role),
        },
      });
      if (response.status === 200) {
        this.setState({
          successMessage: response.data.message,
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
            isDataFetched: false
          }));
          this.callUserRoleListAPI();
        }, 3000);
      }
    } catch (error) {
      this.setState({
        errorMessage: error.response.data.message,
      });
      // setTimeout(() => {
      //   this.setState((prevState) => ({
      //     errorMessage: "",
      //   }));
      // }, 3000);
    }
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  render() {
    const userRolesList = this.props.userRolesListData.userRolesList;
    // Getting user role from dropdown json
    const rolesOptionsList = this.state.rolesData.map((element, index) => (
      <option key={index} value={element.role_id}>
        {element.role_name}
      </option>
    ));

    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="">
          <div className="row">
            <div className="col-md-4 order-1">
              <h3>User Roles</h3>
            </div>

            <div class="col-xl-8 order-3 order-md-2 d-flex flex-wrap  justify-content-start justify-content-md-end RelatedPartiesList_addRoleBtnWrapper__3C9uO">
                <div class="form-group">
                  <input
                      type="text"
                      className={`form-control ${style.inputSearch}`}
                      id="search"
                      placeholder="Search here"
                      value={this.state.searchKey}
                      onChange={this.onSearchChange}
                    />             
                  </div>
                  <div>
                  <label class="form-control border-0"></label></div>
                  {/* { checkIfPermitted(Permissions.MANAGE_USERS_ROLES) && (  */}
                  <Link to="/app/user-role-creation">
                    <Button color="primary" className={style.addBtn}>
                      <i className="fa fa-plus mr-2"></i>ADD ROLE
                    </Button>
                    </Link>  
                    {/* )}      */}
               </div>
          </div>
          <div className="row">
            <div class="col-md-12 order-2 order-md-3 intro-text">
                <p>
                  This is the list of user roles available on the system. When the
                  new user is created, it is assigned to the user role. The table
                  shows no. of users associated per user role. Add Role button on
                  top will allow to create a new user role and it will be listed
                  on the table below. Please note, the table has delete operation
                  only for the newly created roles. You can not delete the system
                  roles. While deleting the role, you need to move the users to
                  other role as requested in the delete popup. In that case, the
                  user will have permissions as per the new role assigned
                </p>
              </div>
          </div>
          <BootstrapTable
            bordered={false}
            remote={false}
            data={this.state.usersRoleList}
            version="4"
            search={false}
            pagination
            fetchInfo={{
              dataTotalSize: this.props.userRolesListData.userRolesList.total,
            }}
            options={{
              sortName: this.state.sortName,
              sortOrder: this.state.sortOrder,
              onSortChange: this.onSortChange,
              onSearchChange: this.onSearchChange,
              sizePerPage: 10,
              page: this.state.page,
              onPageChange: this.onPageChange,
              noDataText: this.setLoader(),
            }}
          >
            <TableHeaderColumn isKey dataField="role_name" dataSort={true}>
              User Role
            </TableHeaderColumn>
            <TableHeaderColumn dataField="user_count" dataSort={true}>
              No. of Users
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="created_at"
              dataSort={true}
              dataFormat={dateFormatter}
            >
              Creation Date
            </TableHeaderColumn>
            <TableHeaderColumn dataField="role_status" dataSort={true}>
              Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="actions"
              dataFormat={this.actionsFormatter.bind(this)}
              width="20%"
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
        {/* Open a modal for delete reason */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className={style.deleteReason}
          centered
        >
          <ModalHeader toggle={this.toggle} className={style.deleteModalHeader}>
            Delete user role
          </ModalHeader>
          <ModalBody>
            <div className={style.deleteReasonFormWrapper}>
              <form onSubmit={this.onSubmit}>
                <div className="form-group">
                  <label htmlFor="assign_role">
                    Please select the new user role below
                  </label>
                  <select
                    className="form-control"
                    id="assign_role"
                    onChange={this.onChangeHandler}
                  >
                    {rolesOptionsList}
                  </select>
                </div>
                <div className={style.error}>{this.state.errorField}</div>
                <div className={`row ${style.deleteBtnWrapper}`}>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="ttm-primary-btn mb-2">
                      Delete
                    </button>
                  </div>
                </div>
                <div className="row">
                  <p className={`statusSucesssMessage ${style.textCenter}`}>
                    {this.state.successMessage}
                  </p>
                  <p className={`statusErrorMessage ${style.textCenter}`}>
                    {this.state.errorMessage}
                  </p>
                </div>
                <p>
                  Please note, you are about to delete the user role which may
                  have users associated. You need to select the new user role on
                  the list below where these users will be moved. These users
                  will have permissions as per the new user role assigned.
                </p>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRolesListData: state.userRolesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserRolesList: (searchKey, sortBy, page) =>
      dispatch(fetchUserRolesList(searchKey, sortBy, page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersRoleList);
